<template>
  <div>
    <div style="position:absolute;top:5px;left:0px;z-index:3000;">
      <svg width="68" height="21" viewBox="0 0 68 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H65.3247C66.781 0 67.7491 1.50674 67.1437 2.83132L59.3746 19.8313C59.0492 20.5433 58.3383 21 57.5555 21H0V0Z" :fill="getFillColor()"/>
      </svg>
    </div>
    <div style="position:absolute;top:8px;left:5px;z-index:3001;color:#ffffff;font-weight:500;font-size:12px;width:60px;text-align:left;">{{discount.toFixed(0)}}% OFF</div>
  </div>
</template>

<script>
import colors from '@/mixins/colors'
export default {
  props: ['discount'],
  mixins: [colors],
  methods: {
    getFillColor () {
      return this.getCssColor('primary_bt')
    }
  }
}
</script>

<style>

</style>
